import { General_Interface } from "../../General_Interface";

export interface DataEntity_Main_04_Interface {
    id:number,
    calibration_id:number,
    filename:Array<General_Interface>,
    pdf_src:string,
    manufacture:string,
    model:string,
    type:string,
    
    range_nominal:string,
    range_nominal_unit:string,

    capability:string,
  
     ////Mohit
     temperature_Air_before:string,
     temperature_Air_after:string,
  
     humidity_Air_before:string,
     humidity_Air_after:string,
  
     pressure_before:string,
     pressure_after:string,
  
  }
  
  export function Empty_DataEntity_Main_04_Interface():DataEntity_Main_04_Interface{
      return{
          id:0,
          calibration_id:0,
          filename:[],
          pdf_src:'',
          manufacture:'',
          model:'',
          type:'',


          capability:'',
          range_nominal:'',
          range_nominal_unit:'',
  
          ////Mohit
  
  
          temperature_Air_before:'',
          temperature_Air_after:'',
  
          humidity_Air_before:'',
          humidity_Air_after:'',
  
          pressure_before:'',
          pressure_after:'',
  
      }
    }
  